import ImageCdn from '@/components/common/ImageCdn.vue';
export default {
  components: {
    ImageCdn
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    notLimitSelectLayer1: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const rankClass = rank => {
      return rank === 0 ? 'first' : rank === 1 ? 'second' : rank === 2 ? 'third' : 'ranknumber';
    };
    const imageFail = event => {
      event.target.style.display = 'none';
    };
    const imageLoad = event => {
      // 利用這個換頁後清掉上頁的 display css
      event.target.style.display = 'inherit';
    };
    return {
      rankClass,
      imageFail,
      imageLoad
    };
  }
};